import { render, staticRenderFns } from "./HwDictSelect.vue?vue&type=template&id=65f8c797&scoped=true"
import script from "./HwDictSelect.vue?vue&type=script&lang=js"
export * from "./HwDictSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f8c797",
  null
  
)

export default component.exports